import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { initLogger } from "./utils/loggerManager";
import "./i18n";

initLogger();

import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import reducers from "./reducers";
import reduxThunk from "redux-thunk";
import ReduxToastr from "react-redux-toastr";
import moment from "moment";
import Moment from "react-moment";
import { registerDateLocales, setDateLocale } from "./utils/dateConfig";
import "moment-timezone";
import i18n from "./i18n";

registerDateLocales();
setDateLocale(i18n.language);

import { getGeoIP } from "./utils/utils";

// global.BASE_API = "http://localhost:8080/api/"; // local
//global.BASE_API = "https://app.plain.ninja/saas/api/"; // prod
// global.BASE_API = 'http://192.168.1.53:8080/api/'; // local

global.BASE_API = process.env.REACT_APP_BASE_API;
global.BASE_WS = process.env.REACT_APP_BASE_WS;
global.REACT_APP_MAGIC_URL = process.env.REACT_APP_MAGIC_URL;
// console.log(process.env);
// console.log(global.BASE_API);
global.API_KEY = "9cb029da-b5a6-429e-8184-4ebfb89a732c"; // temp

Moment.globalMoment = moment;
Moment.globalFormat = "D MMM YYYY";
Moment.globalLocal = true;

// geolocation + IP
// getGeoIP(); // REMOVED: Now called in render logic

const store = createStore(
	reducers, // all reducers
	{}, // initial state
	applyMiddleware(reduxThunk)
);

function getCookie(name) {
	const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
	return match ? decodeURIComponent(match[2]) : null;
}

function shouldRedirectToClockin() {
	// const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
	// 	window.navigator.standalone === true;
	const isRootPath = window.location.pathname === "/";
	const hasToken = !!getCookie("timeRegistrationToken");

	// console.log(`isStandalone: ${isStandalone}, isRootPath: ${isRootPath}, hasToken: ${hasToken}`);

	return isRootPath && hasToken;
}

if (shouldRedirectToClockin()) {
	window.location.replace("/clockin");
} else {
	getGeoIP().then(() => {
		ReactDOM.render(
			<Provider store={store}>
				<App />
				<ReduxToastr
					timeOut={15000}
					newestOnTop={true}
					preventDuplicates
					position="top-right"
					getState={(state) => state.toastr}
					transitionIn="fadeIn"
					transitionOut="fadeOut"
					closeOnToastrClick
				/>
			</Provider>,
			document.getElementById("app")
		);
	});
}

serviceWorker.unregister();
